import React from 'react';
import { Accordion } from 'react-bootstrap';

type IProps = {
  text?: string;
};
const CommAccordian = ({ text }: IProps) => {
  return (
    <Accordion defaultActiveKey='0'>
      <Accordion.Item eventKey='1'>
        <Accordion.Header className='acc_item'>
          {`${text?.slice(0, 10)} ...`}
        </Accordion.Header>
        <Accordion.Body style={{ padding: 0, textAlign: 'start' }}>
          {text}
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default CommAccordian;
